module.exports = __webpack_public_path__ + "static/media/ic_delete.8a283d85.svg";